import { COULEURS_MARKER, AZIMUT } from './iconMarkerConf';

export const TAILLE_ICON_GRAND = 50;
export const TAILLE_ICON_PETIT = 38;
export const TAILLE_ICON_LARGEUR = 40;
export const TAILLE_ICON_HAUTEUR = 60;

const hauteurDuFichier = 2569;
const largeurDuFichier = 530;

function findAzimut(azimut) {
  const result = AZIMUT.find((option) => {
    return (azimut >= option.min && azimut <= option.max)
      || (option.min2 && azimut >= option.min2 && option.max2 && azimut <= option.max2);
  });
  if (result) return result.value;
  return 0;
}
export function iconColorGetter(color, tailleDemande, azimutDemande, afficherAzimut) {
  let taille = tailleDemande;
  if (!taille) {
    taille = TAILLE_ICON_PETIT;
  }
  let azimut = azimutDemande;
  if (azimut === null || azimut === undefined || !afficherAzimut) {
    azimut = 'aucun';
  }
  azimut = findAzimut(azimut);
  const ratio = taille / TAILLE_ICON_HAUTEUR;
  return {
    url: '/static/img/icons.png',
    scaledSize: { width: largeurDuFichier * ratio, height: hauteurDuFichier * ratio, f: 'px', b: 'px' },
    size: { width: TAILLE_ICON_LARGEUR * ratio, height: taille, f: 'px', b: 'px' },
    origin: { x: azimut * TAILLE_ICON_LARGEUR * ratio, y: COULEURS_MARKER[color.toLowerCase()] * TAILLE_ICON_HAUTEUR * ratio, f: 'px', b: 'px' },
  };
}



// WEBPACK FOOTER //
// ./src/services/general/iconColorGetter.js